const ApiErrorCode = {
  0: "Success",
  1: "Internal server error",
  2: " ",
  3: "Token expired",
  4: "Invalid token",
  5: "Requested record not exist",
  6: "Bad request",
  7: "Record already exist",
  9: "Unauthorized",

  1001: "Email required",
  1002: "Password is required",
  1003: "Email does not exists",
  1004: "Invalid password!",
  1005: "Current password is incorrect",
  1006: "Email already exist",
  1007: "User account has been deleted",
  1008: "User account is pending",
  1009: "User account is blocked",
  1010: "OTP expired",
  1011: "Wrong OTP",
  1012: "Number already exist",
  1013: "Username already exist",
  1014: "Username not exist",
  1015: "Email and user name does not exists",
  1016: "Password not valid",
  1017: "Phone not exist",
  1018: "Username not proper",
  1019: "Wrong email OTP",
  1020: "Wrong phone OTP",
  1021: "Wrong captcha",
  1022: "Captcha Expired",
  1023: "Wrong answers",
  1024: "Both otp wrong",
  1040:"Invalid special characters are not allowed.",

  1500: "Leave already exist",
  1501: "Max folder depth reached",
  1502: "Filter already exist.",
  1503: "Folder already exist.",
  1504: "Label already exist.",
  1505: "Invalid parent ",
  1506: "2FA not set ",
  1507: "2FA wrong code ",
};

export const getApiMessage = (code) => {
  return ApiErrorCode[code] || "Something went wrong";
};
